import { Dictionary } from "@insite/client-framework/Common/Types";
import { useEffect, useRef } from "react";

export interface SyncScrollElement extends HTMLElement {
    eX?: number;
    eY?: number;
}

const names: Dictionary<any> = {};

const useSyncScroller = <T>(id: string) => {
    const ref = useRef<SyncScrollElement & T>(null);

    useEffect(() => {
        if (names[id]) {
            names[id].push(ref);
        } else {
            names[id] = [ref];
        }
    }, [id, ref]);

    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const el = ref.current;

        const onScroll = () => {
            const elements = names[id];

            let scrollX = el.scrollLeft;
            let scrollY = el.scrollTop;

            const xRate = scrollX / (el.scrollWidth - el.clientWidth);
            const yRate = scrollY / (el.scrollHeight - el.clientHeight);

            const updateX = scrollX !== el.eX;
            const updateY = scrollY !== el.eY;

            el.eX = scrollX;
            el.eY = scrollY;

            for (const elem of elements) {
                const otherEl = elem.current;

                if (otherEl !== el) {
                    if (
                        updateX &&
                        Math.round(
                            otherEl.scrollLeft -
                                // eslint-disable-next-line no-cond-assign
                                (scrollX = otherEl.eX =
                                    Math.round(xRate * (otherEl.scrollWidth - otherEl.clientWidth))),
                        )
                    ) {
                        otherEl.scrollLeft = scrollX;
                    }

                    if (
                        updateY &&
                        Math.round(
                            otherEl.scrollTop -
                                // eslint-disable-next-line no-cond-assign
                                (scrollY = otherEl.eY =
                                    Math.round(yRate * (otherEl.scrollHeight - otherEl.clientHeight))),
                        )
                    ) {
                        otherEl.scrollTop = scrollY;
                    }
                }
            }
        };

        el.addEventListener("scroll", onScroll);
        return () => {
            el.removeEventListener("scroll", onScroll);
        };
    }, [id, ref.current]);

    return ref;
};

export default useSyncScroller;
